import React, { useEffect, useState } from "react";
import { useI18n } from "../../i18n";
import api from "../../api";

const Vitamins = ({ profile }) => {
  const { t, lang } = useI18n();
  const [vits, setVits] = useState([]);

  useEffect(() => {
    api.post("/plan/vitamins", profile).then((r) => setVits(r.data.vitamins));
  }, [profile]);

  return (
    <div>
      <div className="mb-6">
        <div className="font-mono text-xs tracking-widest text-white/40 mb-1">// {lang === "ro" ? "PROTOCOL" : "PROTOCOL"}</div>
        <h2 className="font-heading text-3xl text-white">{lang === "ro" ? "Vitamine pe zi" : "Vitamins per day"}</h2>
        <div className="font-mono text-[11px] tracking-wider text-white/50 mt-1">
          {lang === "ro" ? "Dozele afișate sunt cantități ZILNICE (nu pe săptămână)." : "Doses shown are DAILY (not weekly)."}
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {vits.map((v) => (
          <div key={v.key} className="sne-card" data-testid={`vit-${v.key}`}>
            <div className="font-mono text-xs tracking-widest text-[#FF3B30] mb-2">{v.key.replace("_", " ").toUpperCase()}</div>
            <h3 className="font-heading text-2xl mb-2">{v[`label_${lang}`] || v.label_en}</h3>
            {(v[`info_${lang}`] || v.info_en) && (
              <div className="mb-4 p-3 text-sm text-white/80" style={{ background: "#1A1A1A", borderLeft: "2px solid #FF3B30" }}>
                <span className="font-mono text-[10px] tracking-widest text-[#FF3B30] mr-2">ℹ INFO</span>
                {v[`info_${lang}`] || v.info_en}
              </div>
            )}
            <Row label="DOSE" value={v[`dose_${lang}`] || v.dose_en} />
            <Row label="TIMING" value={v[`timing_${lang}`] || v.timing_en} />
            <Row label="SOURCES" value={v[`sources_${lang}`] || v.sources_en} />
            <Row label="WHY" value={v[`rationale_${lang}`] || v.rationale_en} />
            {v.priority === "critical" && (
              <div className="mt-3 font-mono text-xs text-[#FF3B30]">⚠ CRITICAL FOR YOUR PROFILE</div>
            )}
            {v.medical_required && (
              <div className="mt-3 font-mono text-xs text-amber-400">⚠ BLOOD TEST RECOMMENDED</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="mb-3">
    <div className="font-mono text-[10px] tracking-widest text-white/40">{label}</div>
    <div className="text-sm text-white mt-1">{value}</div>
  </div>
);

export default Vitamins;
